import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Titre from '../UI/Titre.jsx'
import Description from '../UI/Description.jsx';
import Remerciement from '../UI/Remerciement.jsx';
import VoteFields from '../UI/VoteFields.jsx';
import Consent from '../UI/Consent.jsx';
import DonneesPersonnelles from '../UI/DonneesPersonnelles.jsx';
import Temoinage from '../UI/Temoinage.jsx';
import { useCallback, useState } from 'react';
import { ManageCompteur } from '../Services/ManageCompteur.jsx';
import Accueil from '../UI/Accueil.jsx';

function SUR076700({
    interaction,
    afficherAccueil,
    afficherEtapeCollecteParticipation,
    afficherEtapeRemerciement,
    afficherEtapeGRPD,
    afficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeCollecteParticipation,
    changerEtapeRemerciement,
    changerEtapeCollecteParticipationVote,
    setConsent,
    consentGDPR,
    consentImage,
    passerEtapeRGPDEnabled,
    setField,
    saveDonneePersonnelle,
    userInformation,
    donneesPersonnelleValid,
    participation,
    retourAccueil,
    afficherEtapeTemoinage,
    audioBlob,
    setAudioBlob,
    audioURL,
    setAudioURL,
    sendRecordParticipation,
    sendingParticipationState,
    setContinueEnabled,
    setMessageErreur,
    changerEtapeCollecteParticipationVocale,
    changerEtapeCollecteParticipationTexte,
    changerPage,
    handleRememberMeChange,
    rememberMe,
    canDonneesPersonnelleContinue,
    passerPageTemoignage,
}) {


    const { counter, startCountdownTimer, stopCountdownTimer, afficherCompteur, setAfficherCompteur } = ManageCompteur(interaction);

    const handleStartRecording = useCallback((status) => {
        if (status === 'start') {
            startCountdownTimer();
        }
        if (status === 'stop') {
            stopCountdownTimer();
            setAfficherCompteur(false);
        }
    }, [startCountdownTimer, stopCountdownTimer, setAfficherCompteur]);

    const handleAfficherCompteur = useCallback(
        () => {
            setAfficherCompteur(true);
        }, [setAfficherCompteur]
    );
    const [afficherEtapeCollecteParticipationImage, setAfficherEtapeCollecteParticipationImage] = useState(true);

    return (
        <>
            <Row className="custom-title-instructions">
                <Col>
                    <Titre interaction={interaction} />
                </Col>
            </Row>
            {afficherAccueil &&
                // Page d accueil
                <>
                    <Accueil
                        interaction={interaction}
                        changerPage={changerAfficherEtapeCollecteParticipation}
                    />
                </>
            }
            {afficherEtapeCollecteParticipation &&
                // Page de collecte de participation (limité à 1 vote ou non)
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>

                    <Row className="custom-collecte-participation">
                        <Col>
                            <VoteFields
                                choices={interaction.choices}
                                participation={participation}
                                changerPage={changerPage}
                            />
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>

                </>
            }
            {afficherEtapeTemoinage &&
                <Row className="custom-collect-temoignage">
                    <Col>
                        <Temoinage
                            interaction={interaction}
                            audioURL={audioURL}
                            setAudioURL={setAudioURL}
                            audioBlob={audioBlob}
                            setAudioBlob={setAudioBlob}
                            sendRecordParticipation={sendRecordParticipation}
                            maxRecordingTime={interaction.max_recording_time}
                            setContinueEnabled={setContinueEnabled}
                            setMessageErreur={setMessageErreur}
                            sendingParticipationState={sendingParticipationState}
                            participation={participation}
                            changerEtapeCollecteParticipationTexte={changerEtapeCollecteParticipationTexte}
                            changerEtapeCollecteParticipationVocale={changerEtapeCollecteParticipationVocale}
                            retourAccueil={retourAccueil}
                            handleStartRecording={handleStartRecording}
                            counter={counter}
                            afficherCompteur={afficherCompteur}
                            handleAfficherCompteur={handleAfficherCompteur}
                            setAfficherEtapeCollecteParticipationImage={setAfficherEtapeCollecteParticipationImage}
                            passerPageTemoignage={passerPageTemoignage}
                        />
                    </Col>
                </Row>
            }
            {afficherEtapeCollectInformationsPersonnelles &&
                <>

                    <DonneesPersonnelles
                        interaction={interaction}
                        setField={setField}
                        userInformation={userInformation}
                        donneesPersonnelleValid={donneesPersonnelleValid}
                        handleRememberMeChange={handleRememberMeChange}
                        rememberMe={rememberMe}
                        canDonneesPersonnelleContinue={canDonneesPersonnelleContinue}
                        saveDonneePersonnelle={saveDonneePersonnelle}
                    />
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de collecte de données personnelles
            }
            {afficherEtapeGRPD &&
                <>
                    <Row className="custom-consent">
                        <Col>
                            <Consent
                                customisation={interaction.segment_customisation}
                                consentGDPR={consentGDPR}
                                consentImage={consentImage}
                                setConsent={setConsent}
                            />
                        </Col>
                    </Row>
                    <Row className="custom-commandes">
                        <Col>
                            <Button onClick={changerEtapeRemerciement} disabled={!passerEtapeRGPDEnabled}>Continuer</Button>
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de consentement
            }
            {afficherEtapeRemerciement &&
                <>
                    <Row className="custom-commandes">
                        <Col>
                            <Remerciement interaction={interaction} >Continuer</Remerciement>
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de remerciemeent
            }
        </>
    )
}
export default SUR076700;
